import React, { useEffect, useState } from "react"
import { Flex, Box } from "@rebass/grid/emotion"
import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"
import { ButtonWildMen } from "@nutrafol/nutrafol-ui-kit/dist/ButtonWildMen"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import HeadspaceOne from "../../../headspace/subscription-includes-men"
import useQueryParam from "../../../../../hooks/useIsQueryParam"
import { queries } from "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"
import { classNames } from "../../../../../utils/general"
import { readCookie } from "../../../../../utils/cookies"
import TravelKitCard from "../../gwp/gwpcatccard"

const AltContentsContainer = styled.div`
  width: 100%;
  max-width: 440px;
  @media (min-width: 768px) {
    max-width: none;
  }
`
const ButtonsWrap = styled(Flex)`
  margin-left: auto;
  flex-direction: column;
`
const RadioHolder = styled.div`
  position: relative;
  width: 100%;
  border-radius: 4px;
  margin: 0 0 8px;
  padding: 0;
  height: auto;
  z-index: 5;
`
const RadioWrap = styled.button`
  width: 100%;
  font-size: 0;
  position: relative;
  border-radius: 4px;
  background: ${theme.wild.color.master.base.default};
  border: 1px solid ${theme.wild.color.men.base.alt.default};
  padding: 14px 16px;
  @media (min-width: 768px) {
    height: auto;
    min-height: auto;
    &:not(.option-0) {
      padding: 16px 16px 15px;
    }
  }
  &:not(:last-of-type) {
    margin-bottom: 8px;
    // men/partnership/shampoo-conditioner/ has 2 options only

    &.options-2 {
      @media (min-width: 1024px) {
        margin-bottom: 16px;
      }
    }
  }
  span:not(.hidden, .atc-test-control, .block) {
    display: inline;
  }
  svg {
    display: inline-block;
  }
  &.selected {
    background: ${theme.wild.color.master.secondary.alt};
    border-color: ${theme.wild.color.master.secondary.secondary};
    .radio-button {
      border: 7px solid ${theme.wild.color.master.secondary.default};
    }
    .c-savings {
      background: ${theme.wild.color.master.base.default};
    }
  }
  .radio-button-flex {
    width: 32px;
    padding-right: 2px;
    @media (min-width: 340px) {
      width: 38px;
      padding-right: 16px;
    }
  }
  .radio-button {
    height: 22px;
    width: 22px;
    margin-top: 2px;
    border-radius: 50%;
    position: relative;
    border: 1px solid ${theme.wild.color.men.base.alt.default};
    background: ${theme.wild.color.master.base.default};
    ${queries.medium`
      margin-top: 0;
    `}
    ${queries.large`
      margin-top: 2px;
    `}
  }

  .body--small.c-strike {
    text-decoration: line-through;
    line-height: 18px;
    font-size: 12px;
    flex: 1;
    text-align: right;
  }
  &.normal {
    border-radius: 8px;
    padding: 8px;
  }

  &.has-savings-tag&:first-of-type {
    margin-top: 28px;
    border-top-right-radius: 0;

    &:before {
      content: ${(props) => `"${props.savingstag}"`};
      display: block;
      position: absolute;
      color: #fff;
      width: 142px;
      height: 28px;
      top: -28px;
      right: -1px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      font-size: 12px;
      line-height: 28px;
      font-style: normal;
      font-weight: 400;
      letter-spacing: 0.84px;
      text-transform: uppercase;
      font-family: ${theme.wild.font.dinamo.mono};
      background: ${theme.wild.color.men.secondary.default};

      @media (min-width: 1024px) {
        width: 160px;
        font-size: 14px;
      }
    }
  }
`
const RadioRow = styled(Flex)`
  flex-direction: row;
  &.row0 {
    span:not(.c-savings) {
      line-height: 24px !important;
      @media (min-width: 440px) {
        line-height: 22px !important;
      }
      @media (min-width: 768px) {
        line-height: 22px !important;
      }
      @media (min-width: 1024px) {
        line-height: 26px !important;
      }
    }
  }
  &.row1 {
    margin: 8px 0 0 0;
  }
  .c-price {
    flex: 1;
    text-align: right;
    @media (min-width: 768px) and (max-width: 1023px) {
      &.textelement.men[class*="title--small"] {
        font-size: 20px;
      }
    }
  }
  .c-title {
    text-align: left;
    margin-right: 8px;
    @media (min-width: 768px) {
      //max-width: 182px;
      @media (max-width: 1023px) {
        &.textelement.men[class*="title--small"] {
          font-size: 20px;
        }
      }
    }
  }
  .c-savings {
    padding: 0;
    text-align: center;
    width: 24%;
    height: 18px;
    transform: translate(0, 2px);
    max-width: 67px;
    font-size: 10px !important;
    background: ${theme.wild.color.master.secondary.alt};
    color: ${theme.wild.color.master.secondary.default};
    line-height: 18px !important;
    @media (min-width: 1024px) {
      transform: translate(0, 3px);
    }
  }
  .c-description {
    width: 81%;
    text-align: left;
    span.body--small {
      font-family: "Dinamo Regular", Helvetica, Arial, sans-serif !important;
    }
    @media (min-width: 1024px) {
      max-width: none;
      padding-right: 12px;
      width: 90%;
    }
  }
`
const BuyOnce = styled.div`
  border-bottom: 1px solid ${theme.wild.color.master.base.alt.secondary};
`

const atcText = "ADD TO CART"

const MenOptionsTest = (props) => {
  const { atcData, activeOption, setActiveOption } = props.state
  const { atcCard } = props
  const { handleGwpModal } = props
  const { savingstag, gift, upsellCallback } = props
  const [isFloat, setIsFloat] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [hasProductBeenSelected, setHasProductBeenSelected] = useState(false)
  const [triggerSelection] = useQueryParam()

  useEffect(() => {
    // add this cookie to charge shipping
    document.cookie = "atc_test=group_1;path=/;secure"
  }, [])

  useEffect(() => {
    if (typeof document !== "undefined") {
      const handleClick = (evt) => {
        evt = evt || window.event
        if (
          Array.from(evt.target.classList).indexOf("buttonsfloat") === -1 &&
          isFloat
        ) {
          setIsFloat(false)
        }
      }
      const handleKey = function (evt) {
        evt = evt || window.event
        var isEscape =
          evt &&
          (evt.key === "Escape" || evt.key === "Esc" || evt.keyCode === 27)
        if (isEscape) {
          if (isFloat) {
            setIsFloat(false)

            const header = document.querySelector("header")
            const main = document.querySelector("main")
            const footer = document.querySelector("footer")

            header && header.setAttribute("data-mousedown", "1")
            main && main.setAttribute("data-mousedown", "1")
            footer && footer.setAttribute("data-mousedown", "1")
          }
        }
      }
      document.addEventListener("click", handleClick)
      document.addEventListener("keydown", handleKey)
      return () => {
        document.removeEventListener("click", handleClick)
        document.removeEventListener("keydown", handleKey)
      }
    }
  }, [isFloat])

  if (!atcData) {
    return null
  }

  const options = atcData.options
  const purchase_source = atcData.purchase_source
  const oneTimePrice = options[options.length - 1].price

  if (!options) {
    return null
  }

  triggerSelection(options, activeOption, setActiveOption)

  const atcClick = (e, idx) => {
    if (isSubmitted) {
      return
    }

    if (!isFloat) {
      const option = idx ? options[idx] : options[activeOption]
      // fire product selected segment when user adds default option to cart
      if (!hasProductBeenSelected) {
        onSelect(null, option)
      }
      setIsSubmitted(true)

      let params = option.sku

      /*
       * NT2-21024   [FE] Men's Active Cleanse | Partner LP | Segment Events
       */
      if (gift?.coupon) {
        segmentEvent("Gift Added", gift)
        params += `&code=${gift.coupon}`
      }

      // NT2-23171 - GWP travel kit
      if (option?.ui_data?.coupon) {
        params += `&code=${option.ui_data.coupon}`
      }

      const url = `${process.env.GATSBY_MAGENTO_URL}dpa/add/tocart/?skus=${params}&purchase_source=${purchase_source}`
      const queryID = readCookie("queryID")

      const handleUpsellFlow = (upsellFlow = false) => {
        if (upsellFlow) {
          const body = { skus: option.sku, purchase_source }
          fetch(
            `${process.env.GATSBY_MAGENTO_URL}rest/V1/repack/add_to_cart/`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(body),
            }
          )
            .then((res) => res.json())
            .then((resJson) => {
              setIsSubmitted(false)
              upsellCallback(resJson)
            })
            .catch((error) => {
              setIsSubmitted(false)
              /*
               * if add to cart ajax fails on BE - making regular DPA redirect
               */
              window.location.href = url
              console.error("Error:", error)
            })
        } else {
          window.location.href = url
        }
      }

      segmentEvent("Product Added", {
        text: atcText,
        name: option?.ui_data?.segmentName
          ? option.ui_data.segmentName
          : option.name,
        sku: option.sku,
        coupon: option?.ui_data?.coupon || null,
        price: option.price,
        variant: option?.ui_data?.title,
        product_gender: option.product_gender,
        billing_interval: option.billing_interval,
        core_category: option.product_core_category,
        product_category: option.product_category,
        purchase_type: option.purchase_type,
        shipping_interval: option.shipping_interval,
        quantity: 1,
        quiz_reco: false,
        source: purchase_source,
        type: "button_stickynav",
        queryID,
      })
      if (
        typeof upsellCallback === "function" &&
        option.sku === "MENPRO1-S01"
      ) {
        handleUpsellFlow(true)
      } else {
        setTimeout(() => {
          window.location.href = url
        }, 250)
      }
    }
  }

  const onSelect = (idx, product) => {
    const option = product ? product : options[idx]
    setHasProductBeenSelected(true)
    segmentEvent("Product Selected", {
      variant: option?.ui_data?.title,
      core_category: option.product_core_category,
      name: option?.ui_data?.segmentName
        ? option.ui_data.segmentName
        : option.name,
      sku: option.sku,
      price: option.price,
      product_gender: option.product_gender,
      type: "dropdown",
    })
  }

  const renderOptionRadio = (idx) => {
    const option = options[idx]
    const scls = option?.ui_data?.savings ? "has-savings" : ""
    const isSelected = idx === activeOption ? "selected" : ""
    // don't show single bottle
    if (idx > 2) return
    return (
      <RadioWrap
        id={`option-${idx}`}
        key={`opt${idx}`}
        savingstag={savingstag}
        className={`option-${idx} options-${
          options.length
        } ${scls} ${isSelected}  ${savingstag ? "has-savings-tag" : ""}`}
        onClick={(e) => {
          setActiveOption(idx)
          onSelect(idx)
        }}
      >
        <Flex flexWrap="wrap">
          <Box
            width={[null, null, 30, 38]}
            className="flex radio-button-flex"
            pr={[null, null, "8px", "16px"]}
          >
            <div className="radio-button"></div>
          </Box>
          <Box flex="1">
            <RadioRow className={`row0`} data-sku={option?.sku}>
              <TextElementMen
                element="span"
                text={option?.ui_data?.title}
                className="title--small c-title text-master-secondary-default"
              />
              <TextElementMen
                element="span"
                text={option?.ui_data?.savings}
                className={`mono--small c-savings uppercase`}
              />
              <TextElementMen
                element="span"
                text={`$${option?.price}`}
                className="title--small c-price text-master-secondary-default"
              />
            </RadioRow>
            <RadioRow className={`row1`}>
              <span className="c-description">
                <TextElementMen
                  element="span"
                  text={option?.ui_data?.text_description}
                  className="body--small text-master-base-alt-disabled"
                />
                <TextElementMen
                  element="span"
                  text={option?.ui_data?.shippingText}
                  className="block body--small text-master-secondary-secondary mt-2"
                />
              </span>
              <TextElementMen
                element="span"
                text={
                  option?.old_price && option?.old_price !== option.price
                    ? `<span class="sr-only">was</span> $${option?.old_price}`
                    : ``
                }
                className="body--small c-strike text-men-base-alt-alt"
              />
            </RadioRow>
          </Box>
        </Flex>
      </RadioWrap>
    )
  }

  return (
    <AltContentsContainer className={`men-options-radio`}>
      <ButtonsWrap>
        <RadioHolder className="">
          {options.map
            ? options.map((el, idx) => renderOptionRadio(idx))
            : null}
        </RadioHolder>

        <Box mt={[16]} mb={[24, 24, 16, 24]}>
          <HeadspaceOne />
        </Box>

        {atcCard && (activeOption === 1 || activeOption === 2) ? (
          <Box
            pb={[24, 24, 16, 24]}
            onClick={handleGwpModal}
            className="cursor-pointer z-10"
          >
            <TravelKitCard data={atcCard} />
          </Box>
        ) : null}

        <ButtonWildMen
          className={classNames("c-btn pdp-main-atc", {
            disabled: isFloat || isSubmitted,
          })}
          primary
          label={atcText}
          onClick={atcClick}
        />
      </ButtonsWrap>
      {atcData.singleOption ? (
        <BuyOnce className="pt-8 pb-8 sm:pt-6 sm:pb-12 md:pb-16 buy-once">
          <ButtonWildMen
            textLink
            label={`Buy once for $${oneTimePrice}${
              atcData.singleOption.shippingText
                ? ` ${atcData.singleOption.shippingText}`
                : ""
            }`}
            className="block mx-auto"
            onClick={(e) => {
              setActiveOption(3)
              onSelect(3)
              atcClick(e, 3)
            }}
          />
          <TextElementMen
            text="We recommend 3-6 months of consistent use to see results."
            element="p"
            className="pt-2 body--small text-center text-master-primary-default"
          />
        </BuyOnce>
      ) : null}
    </AltContentsContainer>
  )
}

export default MenOptionsTest
